export const MS_IN_MIN = 1000 * 60
export const SEC_IN_MIN = 60
export const MS_IN_SEC = 1000
